// will be mocked for tests
/**
 * Be careful if you use this! It should only be relevant for local development and
 * usually your dev build and production build should behave the same.
 */
export const backendStage = import.meta.env.VITE_BACKEND_STAGE;
